import { useMemo } from 'react';

import headerPlaceholder from '@assets/images/loading-header.png';
import getImageWithExtension from '@utils/images/getImageWithExtension';
import { sortFoodCategory } from '@utils/shop';
import { URLS } from '@services/images/constants';
import getFullImageUrl from '@services/images/getFullImageUrl';
import useScreenWidthImage from './useScreenWidthImage';

function getShopHeaderImage({ image, width }) {
  return getFullImageUrl({
    image,
    url: URLS.PROFILE_HEADERS,
    quality: 70,
    width,
  });
}

function getShopHeaderCategoryImage({ image, width }) {
  return getFullImageUrl({
    image,
    url: URLS.HEADER_BACKGROUNDS,
    quality: 70,
    width,
  });
}

function useShopHeaderImage({ headerImage, categories } = {}) {
  const imageWidth = useScreenWidthImage();

  const src = useMemo(() => {
    if (!imageWidth) return '';

    if (headerImage || categories) {
      const width = imageWidth;

      if (headerImage) {
        return getShopHeaderImage({ width, image: headerImage });
      }

      if (categories && categories.length > 0) {
        const topCategories = categories.sort(sortFoodCategory);
        const { image } = topCategories[0];
        if (image) {
          return getShopHeaderCategoryImage({
            width,
            image: getImageWithExtension(image),
          });
        }
      }
    }

    return headerPlaceholder;
  }, [categories, headerImage, imageWidth]);

  return src;
}

export default useShopHeaderImage;
